export const titleStyles = {
  display: "flex",
  justifyContent: "space-between",
  marginBottom: "10px",
  margin: '10px 0px',
  padding: '0px 15px'
};
